import { compressToBase64 as lzCompressToBase64, decompressFromBase64 as lzDecompressToBase64 } from 'lz-string';
export const compressToBase64 = (data) => {
    if (!data)
        return undefined;
    return lzCompressToBase64(JSON.stringify(data));
};
export const decompressFromBase64 = (dataStringified) => {
    if (!dataStringified)
        return undefined;
    return JSON.parse(lzDecompressToBase64(dataStringified));
};
